'use client';

import { useRegion } from '~/region/hooks';
import { getWeight } from '~/utils';

export const Weight = ({ weight }: { weight: number }) => {
  const { isUs } = useRegion();

  return <div>{getWeight({ weight, isUs })}</div>;
};
